<template>
  <div class="ds-context-menu-group" :class="[positionX, positionY]" :style="position">
    <template v-for="(menu, index) in list">
      <div v-if="menu.divided" :key="index" class="ds-context-menu-divided"></div>
      <div
        v-else-if="!contextMenuRoot.isHide(menu)"
        :key="index"
        class="ds-context-menu-item"
        :class="{disabled: contextMenuRoot.isDisabled(menu)}"
        @mouseenter="$set(menu, 'childrenShow', true)"
        @mouseleave="$set(menu, 'childrenShow', false)"
      >
        <div class="ds-context-menu-item-content" :class="{'has-icon': hasIcon}" @click.stop="contextMenuRoot.itemClick(menu, $event)">
          <i v-if="menu.icon" class="ds-context-menu-item-icon iconfont" :class="[menu.icon]" :style="{color: menu.color}"></i>
          <span class="ds-context-menu-item-name">{{ menu.name }}</span>
        </div>
        <i class="iconfont icon-right" :show="menu.children && menu.children.length"></i>
        <template v-if="menu.children && menu.children.length">
          <dsf-context-menu-group v-if="menu.childrenShow" :list="menu.children" />
        </template>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "DsfContextMenuGroup",
  inject: ['contextMenuRoot'],
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      positionX: 'right',
      positionY: 'bottom',
      top: 0,
      left: 0
    }
  },
  computed: {
    hasIcon() {
      return !!_.find(this.list, it => !!it.icon);
    },
    position() {
      let res = {};
      if (this.positionX === 'right') {
        res.left = this.left + 'px';
      }
      if (this.positionY === 'bottom') {
        res.top = this.top + 'px';
      }
      return res;
    }
  },
  mounted() {
    let { innerWidth, innerHeight } = window;
    let { top, bottom, left, right, width, height } = this.$el.getBoundingClientRect();
    let _left = innerWidth - right - 15;
    let _top = innerHeight - bottom - 15;
    if (right - innerWidth > 0) {
      if (left - width > 0) {
        this.positionX = 'left';
      } else if (_left < 0) {
        if (left + _left < 0) {
          _left = -left;
        }
        this.left = _left;
      }
    }
    if (bottom - innerHeight > 0) {
      if (top - height > 0) {
        this.positionY = 'top';
      } else if (_top < 0) {
        if (top + _top < 0) {
          _top = -top;
        }
        this.top = _top;
      }
    }
  }
}
</script>